module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI4LjM1IDkuMjUzMDNMMjYuNzQ2OSA3LjY0OTlMMTggMTYuNDI0OUw5LjI1MzE1IDcuNjQ5OUw3LjY1MDAyIDkuMjUzMDNMMTYuNDI1IDE3Ljk5OTlMNy42NTAwMiAyNi43NDY4TDkuMjUzMTUgMjguMzQ5OUwxOCAxOS42MDNMMjYuNzQ2OSAyOC4zNDk5TDI4LjM1IDI2Ljc0NjhMMTkuNjAzMSAxNy45OTk5TDI4LjM1IDkuMjUzMDNaIiBmaWxsPSIjMkUzODNFIiBmaWxsLW9wYWNpdHk9IjAuNSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newhome/close.svg
// module id = t1G2
// module chunks = 0